var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpHandIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#UpHandIcon_svg__clip0_23_2993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.336 7.359a.78.78 0 01.03-.287.723.723 0 01.132-.248.635.635 0 01.21-.168c.08-.04.166-.06.253-.06H3.16c.166 0 .326.074.444.206.117.132.184.31.184.496v6.667a.746.746 0 01-.184.496.596.596 0 01-.444.206h-.68a.593.593 0 01-.425-.185.735.735 0 01-.2-.456l-.52-6.667zm4.335-.28c0-.293.163-.556.4-.68.518-.274 1.4-.822 1.797-1.564.513-.955.61-2.682.625-3.077.003-.056.001-.111.008-.166.085-.685 1.268.115 1.722.961.246.46.277 1.062.252 1.534-.028.504-.16.99-.29 1.474l-.276 1.03h3.408c.097 0 .192.025.28.074a.649.649 0 01.22.204.746.746 0 01.117.294.784.784 0 01-.013.32l-1.686 6.673a.71.71 0 01-.225.369.586.586 0 01-.38.142H6.3a.596.596 0 01-.444-.206.746.746 0 01-.184-.496V7.079z",
    fill: "#1F2CAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "UpHandIcon_svg__clip0_23_2993"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.333 1.333)",
    d: "M0 0h13.333v13.333H0z"
  })))));
}
export default SvgUpHandIcon;